import { c as _c } from "react/compiler-runtime";
import type { Organization } from '@onefootprint/request-types/dashboard';
import { Dropdown } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type TenantItemProps = {
  tenant: Organization;
  children: string;
  onClick: () => void;
  disabled?: boolean;
};
const TenantItem = t0 => {
  const $ = _c(9);
  const {
    tenant,
    children,
    onClick,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav.tenantsList"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== children || $[2] !== disabled || $[3] !== onClick || $[4] !== t || $[5] !== tenant.id || $[6] !== tenant.isAuthMethodSupported || $[7] !== tenant.name) {
    t2 = tenant.isAuthMethodSupported && <Dropdown.Item variant="radio" data-testid="tenant-item" aria-label={t(_temp, {
      tenantName: tenant.name
    })} value={tenant.id} onSelect={onClick} disabled={disabled} className="text-body-3 !px-2 !h-8 !gap-2">{children}</Dropdown.Item>;
    $[1] = children;
    $[2] = disabled;
    $[3] = onClick;
    $[4] = t;
    $[5] = tenant.id;
    $[6] = tenant.isAuthMethodSupported;
    $[7] = tenant.name;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default TenantItem;
function _temp($) {
  return $.logInTo;
}